import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#070A13] text-white p-6" data-testid="error-boundary">
          <div className="max-w-md text-center">
            <p className="text-5xl mb-4">⚠️</p>
            <h1 className="font-display font-bold text-2xl mb-2">Something went wrong</h1>
            <p className="text-sm text-[#94A3B8] mb-6">An unexpected error occurred while rendering this page.</p>
            <div className="flex gap-3 justify-center">
              <button onClick={() => { this.setState({ error: null }); window.location.href = '/'; }} className="gx-btn-primary text-sm" data-testid="error-go-home">Go home</button>
              <button onClick={() => window.location.reload()} className="gx-btn-ghost text-sm" data-testid="error-reload">Reload</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
